import { createAction } from 'redux-actions';
import { initialState } from './reducers';
import produce from 'immer';
export const setSubsidiesState = createAction('SUBSIDIES/SET_SUBSIDIES_STATE', (order) => {
    return produce(Object.assign({}, initialState), draft => {
        draft.selectSubsidiesError = null;
        for (const traveller of order.travellers) {
            draft.availableSubsidiesByPassengers[traveller.id] = [];
        }
        for (const traveller of order.travellers) {
            draft.selectedSubsidies[traveller.id] = [];
            if (!traveller.subsidyInfo) {
                draft.availableSubsidiesByPassengers[traveller.id] = [];
            }
            if (traveller.subsidyInfo) {
                for (const subsidy of traveller.subsidyInfo.subsidies) {
                    draft.availableSubsidiesByPassengers[traveller.id].push({
                        id: subsidy.id,
                        type: subsidy.type,
                        name: subsidy.name,
                        description: subsidy.description,
                        validation: subsidy.validation
                    });
                }
            }
        }
    });
});
export const setSubsidiesLoading = createAction('SUBSIDIES/SET_LOADING');
export const setSubsidiesResultsOpen = createAction('SUBSIDIES/SET_RESULTS_OPEN');
export const checkSubsidy = createAction('SUBSIDIES/CHECK_SUBSIDY');
export const setCheckSubsidyResult = createAction('SUBSIDIES/SET_CHECK_SUBSIDY_RESULT');
export const clearSelectedSubsidies = createAction('SUBSIDIES/CLEAR_SELECTED_SUBSIDIES');
export const selectSubsidy = createAction('SUBSIDIES/SELECT_SUBSIDY');
export const setSubsidiesError = createAction('SUBSIDIES/SET_ERROR');
export const selectSubsidies = createAction('SUBSIDIES/SELECT_SUBSIDIES');
export const setCheckedTravellers = createAction('SUBSIDIES/SET_CHECKED_TRAVELLERS');
